import { Dropdown } from 'floating-vue';
import algoliasearch from 'algoliasearch';
import _debounce from 'lodash/debounce';

import SearchWidgetResults from './SearchWidgetResults.vue';

const algoliaIndex = window.drupalSettings.algolia.generalIndex;
const algoliaAppId = window.drupalSettings.algolia.appId;
const algoliaAPIKey = window.drupalSettings.algolia.apiKey;

const client = algoliasearch(algoliaAppId, algoliaAPIKey);

export default {
    props: {
        title: {
            type: String,
        },

        type: {
            type: String,
            default: 'default'
        },

        clearKey: {
            type: Number,
        },
    },

    components: {
        VDropdown: Dropdown,
        SearchWidgetResults,
    },

    mounted() {
    },

    data() {
        return {
            showResults: false,
            hits: [],
            val: '',
            index: client.initIndex(algoliaIndex),
            width: '100px',
            loading: false,
            firstKeyStroke: true,
            isFocused: false,
            filters: {
                archive: `field_date_range < ${new Date().getTime() / 1000} AND (type:concert OR type:festival OR type:academy)`,
                program: `field_date_range > ${new Date().getTime() / 1000} AND (type:concert OR type:festival OR type:academy)`,
                default: `field_date_range > ${new Date().getTime() / 1000}`,
            },
            ph: {
                archive: this.Drupal.t('home.search.ph.archive'),
                program: this.Drupal.t('home.search.ph.program'),
                default: this.Drupal.t('home.search.ph.default'),
            },
            dom: {
                overlayMenus: document.querySelector('.menu-overlay .menu-overlay__menus'),
            }
        };
    },

    computed: {

    },

    methods: {
        onSearchInput: _debounce(function () {
            this.fetchData();
        }, 500),

        fetchData() {
            if (this.val.length) {
                this.index.search(this.val, {
                    filters: this.filters[this.type],
                    hitsPerPage: 5,
                }).then(({ hits }) => {
                    this.hits = hits;
                    this.loading = false;
                    this.showResults = true;
                });
            }
            else {
                this.hits = [];
            }
        },
        onClearClick() {
            this.clear();
        },
        clear() {
            this.val = '';
            this.hits = [];
        },
        highlight(content) {
            if (!this.val) {
                return content;
            }
            return content.replace(new RegExp(this.val, 'gi'), (match) => `<strong>${match}</strong>`);
        },
    },

    watch: {
        val(val) {
            if (val.length && !this.loading) {
                this.loading = true;
            }

            // if (this.type == 'menu-overlay') {
            //     val.length ? this.dom.overlayMenus.style.display = 'none' : this.dom.overlayMenus.style.display = 'block';
            // }
        },
    },
};
